import React from 'react'
import { Box, Flex, Link as ChakraLink, Skeleton, Text } from '@chakra-ui/react'
import Link from 'next/link'
import { FileOrLink } from 'entities/user'

const Attachment = ({
    href,
    label,
    isLoaded,
}: {
    href?: string
    label: string
    isLoaded: boolean
}) => {
    if (isLoaded && !href) {
        return null
    }

    return (
        <Skeleton isLoaded={isLoaded}>
            <Link href={isLoaded ? href! : '#'} passHref>
                <ChakraLink
                    px="10px"
                    py="5px"
                    borderRadius="6px"
                    borderWidth="1px"
                    borderColor="gray.dividers"
                    target="_blank"
                    rel="noopener"
                >
                    {label}
                </ChakraLink>
            </Link>
        </Skeleton>
    )
}

export const Attachments = ({
    isLoaded,
    isFull,
    coverLetter,
    cv,
}: {
    isLoaded: boolean
    isFull: boolean
    coverLetter?: FileOrLink
    cv?: FileOrLink
}) => {
    const cvUrl = cv?.file?.url || cv?.link

    return (
        <Box mt={isFull ? '16px' : '24px'}>
            {!isFull && (
                <Text
                    variant="bodyTextSmall"
                    fontWeight="medium"
                    color="text.secondary"
                    mb="8px"
                >
                    Attachments
                </Text>
            )}
            <Flex flexWrap="wrap" gap="8px">
                <Attachment isLoaded={isLoaded} label="CV" href={cvUrl} />
                <Attachment
                    isLoaded={isLoaded}
                    label="Cover Letter"
                    href={coverLetter?.file?.url}
                />
            </Flex>
        </Box>
    )
}
